import { render, staticRenderFns } from "./StockWarningDialog.vue?vue&type=template&id=2fed2444&lang=pug&"
import script from "./StockWarningDialog.vue?vue&type=script&lang=js&"
export * from "./StockWarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports